var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('p',[_vm._v("Extrato Mensal Inter")]),(!_vm.credential)?_c('div',{staticClass:"btn",attrs:{"id":"buttonDiv"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }